/**
 * Generated runtime TestId mirror for frontend/src/pages/admin/TestDataGenerator.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const TestDataGeneratorTestIds = {
  btnGenerateAttributes: "btn-generate-attributes",
  btnGenerateEntities: "btn-generate-entities",
  btnGenerateErrorLogs: "btn-generate-error-logs",
  cardTitleGenerateAttributes: "card-title-generate-attributes",
  cardTitleGenerateEntities: "card-title-generate-entities",
  cardTitleGenerateErrorLogs: "card-title-generate-error-logs",
  entityProgress: "entity-progress",
  generateAttributesCard: "generate-attributes-card",
  generateEntitiesCard: "generate-entities-card",
  generateErrorLogsCard: "generate-error-logs-card",
  inputEntityCount: "input-entity-count",
  inputValueTemplate: "input-value-template",
  selectAttrEntityType: "select-attr-entity-type",
  selectDefinition: "select-definition",
  selectGeneratorType: "select-generator-type",
  selectIdentityType: "select-identity-type",
  selectPartyType: "select-party-type"
} as const;
